<template>
  <ArenaForm />
</template>
  
<script>
  import ArenaForm from '@/components/tournament-arena/ArenaForm.vue';
  export default {
    name: "TournamentArenaCreatePage",
    components: {
      ArenaForm,
    },
  };
</script>
  